/* ===== Data seeds ===== */
function makeSVG(w,h,txt){
  const svg=`<svg xmlns='http://www.w3.org/2000/svg' width='${w}' height='${h}' viewBox='0 0 ${w} ${h}'>
    <defs><linearGradient id='g' x1='0' x2='1'><stop offset='0' stop-color='#e9f6f8'/><stop offset='1' stop-color='#f9f6ef'/></linearGradient></defs>
    <rect width='100%' height='100%' fill='url(#g)'/>
    <circle cx='${w/2}' cy='${h/2}' r='${Math.min(w,h)/3}' fill='none' stroke='#93c9cf' stroke-width='3'/>
    <text x='50%' y='50%' dominant-baseline='middle' text-anchor='middle' font-size='16' fill='#0F4761' font-family='system-ui,Segoe UI,Roboto'>${txt}</text>
  </svg>`;
  return 'data:image/svg+xml;utf8,'+encodeURIComponent(svg);
}

const FIGURES = Array.isArray(window.productMediaGallery) ? window.productMediaGallery : [];

/* ====== State & utilities ====== */
const $=(s,r=document)=>r.querySelector(s); const $$=(s,r=document)=>Array.from(r.querySelectorAll(s));
const state={selected:null};
function announce(msg){$('#selectionAnnounce').textContent=msg;}
function updateOrderSummary(){
  const sum = state.selected ? state.selected.values.join(' · ') : '—';
  $('#selSummary').textContent=sum; $('#sku').textContent=state.selected?state.selected.sku:'—';
  if(state.selected) announce(`Selected: ${sum}`);
}

/* ===== Spec chips modal ===== */
let lastInvoker=null;
function openSpecModal(selector){
  $(selector).style.display = '';
}

function closeSpecModal(){
  $$('.chip-popup').forEach(b=>b.style.display='none');
  if(lastInvoker) lastInvoker.focus();
}

$$('.chip:not(.inert)').forEach(chip=>{
  chip.addEventListener('click',e=>{ lastInvoker=e.currentTarget; openSpecModal(chip.dataset.modal); });
  chip.addEventListener('keydown',e=>{ if(e.key==='Enter' || e.key===' '){ e.preventDefault(); lastInvoker=e.currentTarget; openSpecModal(chip.dataset.modal``); } });
});

document.addEventListener('click', function (e) {
  const chip = e.target.closest('[data-modal-opener]');
  if (!chip) return;

  lastInvoker = chip;
  openSpecModal(chip.dataset.modal);
});

document.addEventListener('click', function (e) {
  const closebutton = e.target.closest('[data-spec-close]');
  const overlay = e.target.closest('.overlay');
  if (closebutton || overlay) {
    closeSpecModal();
  }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') {
    closeSpecModal();
  }
});

/* ===== Options — table view ===== */
let collapsed = true;
const rows = $$('#optionsRows tr');

// Handle row and dropdown selection
$$('.variant-row').forEach(row => {
  const selects = $$('.option-select', row);
  
  // Check if row is complete (all dropdowns have values)
  function isRowComplete() {
    return Array.from(selects).every(sel => sel.value !== '');
  }
  
  // Update order summary when row or dropdown changes
  function updateSelection() {
    if (isRowComplete()) {
      const opt1 = row.dataset.option1;
      const opt2 = Array.from(selects).find(s => s.dataset.optionIndex === '2')?.value;
      const opt3 = Array.from(selects).find(s => s.dataset.optionIndex === '3')?.value;
      
      state.selected = {
        sku: row.dataset.sku,
        values: [opt1, opt2, opt3]
      };
      updateOrderSummary();
      $$('.variant-row').forEach(r => r.classList.remove('selected'));
      row.classList.add('selected');
    }
  }
  
  row.addEventListener('click', updateSelection);
  selects.forEach(sel => {
    sel.addEventListener('change', updateSelection);
  });
});

/* Button view */
const btnState={serotype:null,size:null};
function renderPills() {
  const sero = $('#serotypePills');
  sero.innerHTML = '';
  OPTION1.forEach(s => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'btn btn-ghost';
    b.textContent = s;
    b.addEventListener('click', () => {
      $$('#serotypePills .btn').forEach(x => x.classList.remove('btn-primary'));
      b.classList.add('btn-primary');
      btnState.serotype = s;
      finalizeBtnView();
    });
    sero.appendChild(b);
  });
  const size = $('#sizePills');
  size.innerHTML = '';
  OPTION2.forEach(s => {
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'btn btn-ghost';
    b.textContent = s;
    b.addEventListener('click', () => {
      $$('#sizePills .btn').forEach(x => x.classList.remove('btn-primary'));
      b.classList.add('btn-primary');
      btnState.size = s;
      finalizeBtnView();
    });
    size.appendChild(b);
  });
}
//renderPills();
function finalizeBtnView() {
    const t = document.querySelector('input[name="btTiter"]:checked')?.value || null;
    if (btnState.serotype && btnState.size && t) {
        const base = OPTIONS.find(o => o.serotype === btnState.serotype) || OPTIONS[0];
        state.selected = {
            sku: base.sku,
            serotype: btnState.serotype,
            size: btnState.size,
            titer: t
        };
        updateOrderSummary();
        $('#btnViewHint').textContent = 'Selection complete.';
    } else $('#btnViewHint').textContent = t ? 'Choose Serotype and Size to finalize.' : 'Titer is required to finalize selection.';
}

$$('input[name="btTiter"]').forEach(r => r.addEventListener('change', finalizeBtnView));

function setView(v) {
    const isTable = v === 'table';
    const tableView = $('#tableView');
    const buttonView = $('#buttonView');

    if (tableView) tableView.style.display = isTable ? 'block' : 'none';
    if (buttonView) buttonView.style.display = isTable ? 'none' : 'block';
    $('#viewTable')?.setAttribute('aria-pressed', String(isTable));
    $('#viewButton')?.setAttribute('aria-pressed', String(!isTable));
}

const viewTableBtn = $('#viewTable');
const viewButtonBtn = $('#viewButton');
if (viewTableBtn) viewTableBtn.addEventListener('click', () => setView('table'));
if (viewButtonBtn) viewButtonBtn.addEventListener('click', () => setView('button'));
setView(viewTableBtn ? 'table' : 'button');

/* Order qty + add to cart */
$('#qtyMinus').addEventListener('click', () => {
    const el = $('#qty');
    el.value = Math.max(1, (+el.value || 1) - 1);
});
$('#qtyPlus').addEventListener('click', () => {
    const el = $('#qty');
    el.value = (+el.value || 1) + 1;
});
// $('#addToCart').addEventListener('click',()=>alert('Added to cart:\n'+($('#selSummary').textContent)));

/* Collapsible sections: robust +/- */
$$('section.card').forEach(sec => {
    const header = $('.header[data-toggle]', sec) || $('.header', sec);
    const btn = $('button.h-toggle', header);
    const sign = $('.sign', header);
    const content = $('.content', sec);
    if (!btn || !content) return; // overview band cards don't collapse
    function setHeight(init = false) {
        const open = sec.getAttribute('aria-expanded') !== 'false';
        btn.setAttribute('aria-expanded', String(open));
        sign.textContent = open ? '–' : '+';
        content.style.maxHeight = open ? content.scrollHeight + 'px' : '0px';
        if (init && open) {
            requestAnimationFrame(() => content.style.maxHeight = content.scrollHeight + 'px');
        }
    }
    // setHeight(true);
    new ResizeObserver(() => {
        if (sec.getAttribute('aria-expanded') !== 'false') {
            content.style.maxHeight = content.scrollHeight + 'px';
        }
    }).observe(content);
    header.addEventListener('click', e => {
        if (e.target.closest('a')) return;
        const open = sec.getAttribute('aria-expanded') !== 'false';
        sec.setAttribute('aria-expanded', String(!open));
        setHeight();
    });
});

/* ===== Galleries ===== */
function initGallery(mainSel,imgSel,thumbSel,capSel, getIndexSetter){
  const main=$(mainSel), img=$(imgSel), thumbs=$(thumbSel), cap=$(capSel);
  let idx=0;
  function set(i){
  idx = i;
  const f = FIGURES[i];
  if (!f) {
    img.src = '';
    img.alt = '';
    cap.textContent = 'No image available';
  } else {
    img.src = f.src;
    img.alt = f.alt;
    cap.textContent = f.alt;
  }
  $$(thumbSel+' img').forEach((im, k) => im.classList.toggle('active', k === i));
  getIndexSetter(idx);
}
  function render(){ thumbs.innerHTML=''; FIGURES.forEach((f,i)=>{ const t=document.createElement('img'); t.src=f.src; t.alt=f.alt; t.width=90; t.height=60; t.addEventListener('click',()=>set(i)); thumbs.appendChild(t); }); }
  render(); set(0);
  main.addEventListener('click',()=>{ currentFig=idx; openLightbox(); });
  main.addEventListener('keydown',e=>{ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); currentFig=idx; openLightbox(); } });
}
let currentFig=0; // shared by lightbox
// Overview gallery
initGallery('#ovMain','#ovMainImg','#ovThumbs','#ovCaption',(i)=>{/* keep local idx via closure */});
// Main gallery
initGallery('#seqMain','#mainImg','#thumbs','#figCaption',(i)=>{/* keep local idx via closure */});

function openLightbox(){ $('#lightOverlay').hidden=false; $('#lightDialog').hidden=false; $('#lightOverlay').classList.add('active'); $('#lightDialog').classList.add('active'); updateLightbox(); trapFocus($('#lightDialog')); }
function closeLightbox(){ $('#lightOverlay').classList.remove('active'); $('#lightDialog').classList.remove('active'); $('#lightOverlay').hidden=true; $('#lightDialog').hidden=true; }
function updateLightbox(){ const f=FIGURES[currentFig]; $('#lightImg').src=f.src; $('#lightImg').alt=f.alt; $('#lightCaption').textContent=f.alt; $('#lightCounter').textContent=`Image ${currentFig+1} of ${FIGURES.length}`; }
$('#lightOverlay').addEventListener('click',closeLightbox);
$('[data-light-close]').addEventListener('click',closeLightbox);
document.addEventListener('keydown',e=>{ if($('#lightDialog').hidden) return; if(e.key==='Escape') closeLightbox(); if(e.key==='ArrowRight'){currentFig=(currentFig+1)%FIGURES.length; updateLightbox();} if(e.key==='ArrowLeft'){currentFig=(currentFig-1+FIGURES.length)%FIGURES.length; updateLightbox();} });
$('#nextFig').addEventListener('click',()=>{currentFig=(currentFig+1)%FIGURES.length; updateLightbox();});
$('#prevFig').addEventListener('click',()=>{currentFig=(currentFig-1+FIGURES.length)%FIGURES.length; updateLightbox();});

/* TOC build + scroll‑spy */
function buildTOC(){
  const list=$('#tocList'); list.innerHTML='';
  $$('#content > section.card').forEach(sec=>{
    const label=$('.h-toggle',sec).textContent; const id=sec.id;
    const a=document.createElement('a'); a.href='#'+id; a.textContent=label;
    a.addEventListener('click',e=>{
      e.preventDefault();
      if(sec.getAttribute('aria-expanded')==='false'){ sec.setAttribute('aria-expanded','true'); const c=$('.content',sec); c.style.maxHeight=c.scrollHeight+'px'; $('.h-toggle',sec).setAttribute('aria-expanded','true'); $('.sign',sec).textContent='–'; }
      sec.scrollIntoView({behavior:'smooth', block:'start'}); history.pushState(null,'','#'+id); $('.h-toggle',sec).focus({preventScroll:true});
    });
    const li=document.createElement('li'); li.appendChild(a); list.appendChild(li);
  });
  const io=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{ const id=entry.target.id; const link=document.querySelector('.toc a[href="#'+id+'"]'); if(entry.isIntersecting){ $$('.toc a').forEach(x=>x.classList.remove('active')); if(link) link.classList.add('active'); } });
  },{rootMargin:'-40% 0px -55% 0px', threshold:0.01});
  $$('#content > section.card').forEach(sec=>io.observe(sec));
}
buildTOC();

/* Documents — download links (works for both Overview key docs + full table) */
$$('[data-dl]').forEach(a=>{
  a.addEventListener('click',e=>{
    e.preventDefault();
    const name=a.dataset.dl;
    let text=''; if(name.endsWith('.gb')) text='LOCUS       VECTORMAP  4700 bp    DNA     circular\nFEATURES    Location/Qualifiers\n     misc_feature    1..4700\n';
    else if(name.endsWith('.pdf')) text='%PDF-1.4\n%Mock Datasheet\n';
    else if(name.endsWith('.txt')) text='Feature list:\nEF1a, DIO, hM3D(Gq), EYFP, WPRE, hGH polyA\n';
    const blob=new Blob([text],{type:name.endsWith('.pdf')?'application/pdf':'text/plain'});
    const url=URL.createObjectURL(blob); a.href=url; a.download=name; a.click(); setTimeout(()=>URL.revokeObjectURL(url),500);
  });
});

/* Supplier ads slider */
const SLIDES = [{
    title: "Supplier Ads Slides show",
    body: "Promote your latest vectors, kits, or services to the BioHippo audience.",
    cta: "Learn more"
}, {
    title: "Get end‑to‑end AAV support",
    body: "Design → packaging → characterization — one PO.",
    cta: "Talk to us"
}, {
    title: "Scale with confidence",
    body: "QC you can trust: ddPCR titer, VP:VG, endotoxin, mycoplasma and more.",
    cta: "See QC panel"
}];

function makeSlide(s) {
    return `<div class="ad-card"><div><h3>${s.title}</h3><p class="small">${s.body}</p><button class="btn btn-primary small">${s.cta}</button></div><div><img alt="" src="${makeSVG(360,180,'Sponsored')}"/></div></div>`;
}
(function initSlider() {
    const wrap = $('#slides');
    if (!wrap) return;
    dots = $('#dots');
    SLIDES.forEach((s, i) => {
        const slide = document.createElement('div');
        slide.className = 'slide';
        slide.innerHTML = makeSlide(s);
        wrap.appendChild(slide);
        const dot = document.createElement('button');
        dot.className = 'dot';
        dot.setAttribute('role', 'tab');
        dot.addEventListener('click', () => go(i, true));
        dots.appendChild(dot);
    });
    go(0);
    startAuto();
})();
let slideIdx = 0,
    timer = null;

function go(i, user = false) {
    slideIdx = i % SLIDES.length;
    $('#slides').style.transform = `translateX(-${slideIdx*100}%)`;
    $$('#dots .dot').forEach((d, idx) => {
        d.classList.toggle('active', idx === slideIdx);
        d.setAttribute('aria-selected', idx === slideIdx ? 'true' : 'false');
    });
    if (user) {
        restartAuto();
    }
}

function next() {
    go((slideIdx + 1) % SLIDES.length);
}

function startAuto() {
    timer = setInterval(next, 5000);
}

function restartAuto() {
    clearInterval(timer);
    startAuto();
}
if ($('#supplierSlider')) {
  $('#supplierSlider').addEventListener('mouseenter', () => clearInterval(timer));
  $('#supplierSlider').addEventListener('mouseleave', restartAuto);
}

/* Focus trap */
function trapFocus(container){
  const focusables=container.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])');
  if(!focusables.length) return; const first=focusables[0], last=focusables[focusables.length-1];
  container.addEventListener('keydown',e=>{
    if(e.key!=='Tab') return;
    if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
  });
  first.focus();
}

/* Deep link */
window.addEventListener('load',()=>{
  const target=location.hash && $(location.hash);
  if(target && $('.h-toggle',target)){ if(target.getAttribute('aria-expanded')==='false'){ target.setAttribute('aria-expanded','true'); const content=$('.content',target); content.style.maxHeight=content.scrollHeight+'px'; $('.h-toggle',target).setAttribute('aria-expanded','true'); $('.sign',target).textContent='–'; } $('.h-toggle',target).focus({preventScroll:true}); }
});

/* Promo modal open/close */
const promoBtn = $('#promoBtn');
const promoOverlay = $('#promoOverlay');
const promoModal = $('#promoModal');
const promoCloseBtn = promoModal && promoModal.querySelector('[data-promo-close]');
if(promoBtn && promoOverlay && promoModal && promoCloseBtn){
  function openPromo(){ promoOverlay.hidden=false; promoModal.hidden=false; promoOverlay.classList.add('active'); promoModal.classList.add('active'); trapFocus(promoModal); }
  function closePromo(){ promoOverlay.classList.remove('active'); promoModal.classList.remove('active'); promoOverlay.hidden=true; promoModal.hidden=true; promoBtn.focus(); }
  promoBtn.addEventListener('click',openPromo);
  promoOverlay.addEventListener('click',closePromo);
  promoCloseBtn.addEventListener('click',closePromo);
  document.addEventListener('keydown',e=>{ if(!promoModal.hidden && e.key==='Escape') closePromo(); });
}

(function buildQuickLinks() {
  var maxLinkToAdd = 4;
  var linksAdded = 0;
  $('.main-grid').querySelectorAll('section').forEach(function(section) {
    if (linksAdded < 4) {
      var text = section.querySelector('.header button').innerText;
      var id = section.getAttribute('id');
      var li = document.createElement('li');
      var anchor = document.createElement('a');
      anchor.setAttribute('href', '#'+id);
      anchor.innerText = text;
      li.appendChild(anchor);
      $('.rail-list').appendChild(li);
      linksAdded++;
      console.log(linksAdded);
      if (linksAdded == 4) {
        var li = document.createElement('li');
        var anchor = document.createElement('a');
        anchor.setAttribute('href', '#desc');
        anchor.classList.add('btn');
        anchor.classList.add('btn-ghost');
        anchor.classList.add('small');
        anchor.style.display = 'inline-block';
        anchor.style.marginTop = '8px';
        anchor.innerText = 'More Info';
        li.appendChild(anchor);
        $('.rail-list').appendChild(li);
      }
    }
  });
})();

(function() {
  function isTableOptionAvailable(priorSelections, testingOptionIndex, testingOptionName) {
    if (!window.productVariants) return true;

    return window.productVariants.some(function(variant) {
      if (!variant.available) return false;

      var variantOptions = [variant.option1, variant.option2, variant.option3];

      for (var idx in priorSelections) {
        if (variantOptions[idx] !== priorSelections[idx]) return false;
      }

      return variantOptions[testingOptionIndex] === testingOptionName;
    });
  }

  function updateTableOptionAvailability() {
    var tableRows = document.querySelectorAll('#optionsRows tr[data-value-id]');
    if (!tableRows.length || !window.productVariants) return;

    tableRows.forEach(function(row) {
      var option1Name = row.dataset.optionName;
      if (!option1Name) return;

      row.querySelectorAll('select[data-option-index]').forEach(function(select) {
        var optionIndex = parseInt(select.dataset.optionIndex, 10);
        var priorSelections = { 0: option1Name };

        for (var i = 1; i < optionIndex; i++) {
          var prevSelect = row.querySelector('select[data-option-index="' + i + '"]');
          if (prevSelect && prevSelect.value) {
            var prevOption = prevSelect.querySelector('option[value="' + CSS.escape(prevSelect.value) + '"]');
            if (prevOption) {
              priorSelections[i] = prevOption.dataset.valueId || prevOption.textContent.trim();
            }
          }
        }

        select.querySelectorAll('option[value]').forEach(function(option) {
          if (!option.value) return;

          var optionName = option.dataset.valueId || option.textContent.trim();
          var available = isTableOptionAvailable(priorSelections, optionIndex, optionName);
          option.disabled = !available;
        });

        if (select.selectedOptions[0] && select.selectedOptions[0].disabled) {
          select.value = '';
        }
      });
    });
  }

  document.addEventListener("change", function(e) {
    const tableSelector = document.querySelector('#optionsRows');
    const variantSelector = document.querySelector('variant-selects');
    if (!variantSelector || !tableSelector) {
      return;
    }

    var row = e.target.closest("tr");
    const rowSelect = e.target.closest("#optionsRows [data-option]");
    if (!row || !rowSelect) return;
    
    var change = false;    
    if (window.productOptions.length > 0) {
      var selectedOption1 = row.dataset.valueId;
      if (selectedOption1) {
        const option1 = variantSelector.querySelector('fieldset[data-option-index="0"]');
        option1.querySelector(`[data-option-value-id="${selectedOption1}"]`).checked = true;
        change = true;    
      }
    }
    if (window.productOptions.length > 1) {
      var selectedOption2 = row.querySelector('select[data-option-index="1"]').value;
      if (selectedOption2) {
        const option2 = variantSelector.querySelector('fieldset[data-option-index="1"]');
        option2.querySelector(`[data-option-value-id="${selectedOption2}"]`).checked = true;
        change = true;    
      }
    }
    if (window.productOptions.length > 2) {
      var selectedOption3 = row.querySelector('select[data-option-index="2"]').value;
      if (selectedOption3) {
        const option3 = variantSelector.querySelector('fieldset[data-option-index="2"]');
        option3.querySelector(`[data-option-value-id="${selectedOption3}"]`).checked = true;
        change = true;    
      }
    }
    if (change) {
      document.querySelector('variant-selects').dispatchEvent(new Event('change'));
      document.querySelectorAll("#optionsRows tr").forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");
    }

    updateTableOptionAvailability();
  });

  document.addEventListener("click", function(e) {
    const tableSelector = document.querySelector('#optionsRows');
    const variantSelector = document.querySelector('variant-selects');
    if (!variantSelector || !tableSelector) {
      return;
    }

    const row = e.target.closest("#optionsRows tr[data-option-index]");
    if (!row) return;


    var empty = false;
    row.querySelectorAll('select[data-option-index]').forEach(function(item) {
      if (!item.value) {
        empty = true;
      }
    });
    if (empty) {
      return;
    }

    var change = false;
    if (window.productOptions.length > 0) {
      var selectedOption1 = row.dataset.valueId;
      if (selectedOption1) {
        const option1 = variantSelector.querySelector('fieldset[data-option-index="0"]');
        option1.querySelector(`[data-option-value-id="${selectedOption1}"]`).checked = true;
        change = true;
      }
    }

    if (window.productOptions.length > 1) {
      var selectedOption2 = row.querySelector('select[data-option-index="1"]').value;
      if (selectedOption2) {
        const option2 = variantSelector.querySelector('fieldset[data-option-index="1"]');
        option2.querySelector(`[data-option-value-id="${selectedOption2}"]`).checked = true;
        change = true;
      }
    }

    if (window.productOptions.length > 2) {
      var selectedOption3 = row.querySelector('select[data-option-index="2"]').value;
      if (selectedOption3) {
        const option3 = variantSelector.querySelector('fieldset[data-option-index="2"]');
        option3.querySelector(`[data-option-value-id="${selectedOption3}"]`).checked = true;
        change = true;
      }
    }

    if (change) {
      document.querySelector('variant-selects').dispatchEvent(new Event('change'));
      document.querySelectorAll("#optionsRows tr").forEach(r => r.classList.remove("selected"));
      row.classList.add("selected");
    }
  });

  subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, function(e) {
    const tableSelector = document.querySelector('#optionsRows');
    const variantSelector = document.querySelector('variant-selects');
    if (!variantSelector || !tableSelector) {
      return;
    }

    var raw = null;
    if (window.productOptions.length > 0) {
      const option1 = variantSelector.querySelector('fieldset[data-option-index="0"]');
      const selectedOption1 = option1 ? option1.querySelector('input:checked').dataset.optionValueId : false;
      if (selectedOption1) {
        row = document.querySelector(`#optionsRows tr[data-value-id = "${selectedOption1}"]`);
      }
    }

    if (!row) {
      return;
    }

    if (window.productOptions.length > 1) {
      const option2 = variantSelector.querySelector('fieldset[data-option-index="1"]');
      const selectedOption2 = option2 ? option2.querySelector('input:checked').dataset.optionValueId : false;
      if (selectedOption2) {
        row.querySelector('select[data-option-index="1"]').value = selectedOption2;
      }
    }
    if (window.productOptions.length > 2) {
      const option3 = variantSelector.querySelector('fieldset[data-option-index="2"]');
      const selectedOption3 = option3 ? option3.querySelector('input:checked').dataset.optionValueId : false;
      if (selectedOption3) {
        row.querySelector('select[data-option-index="2"]').value = selectedOption3;
      }
    }

    document.querySelectorAll("#optionsRows tr").forEach(r => r.classList.remove("selected"));
    row.classList.add("selected");
    updateTableOptionAvailability();
  });

  updateTableOptionAvailability();
})();

/*var raqInterval;
raqInterval = setInterval(function() {
  if (document.querySelector('shopify-forms-embed')) {
    clearInterval(raqInterval);
    var embedForm = document.querySelector('shopify-forms-embed');
    var embedFormShadowRoot = embedForm.shadowRoot;
    
    var embedFormSection = embedForm.closest('section');
    embedFormSection.classList.add('request-quote-form');

    var style = `
      <style>
        #custom\\#product_information {
          display: none;
        }
        #label-custom\\#product_information {
          position: static;
          font-size: 18px;
          color: #000;
        }
        .close-icon {
          position: absolute;
          top: 10px;
          right: 20px;
          border: 1px solid #000;
          padding: 1px 5px;
          z-index: 99;
          cursor: pointer;
        }
      </style>
      <span id="close-form" class="close-icon">CLOSE</span>
    `;

    embedFormShadowRoot.getElementById('app-embed').insertAdjacentHTML('beforeend', style);
    embedFormShadowRoot.getElementById('close-form').addEventListener('click', function() {
      embedFormSection.classList.remove('_show');
    });
  }
},500);

document.querySelector('[data-target="request-quote-form"]').addEventListener('click', function() {
  document.querySelector('.request-quote-popup').classList.add('_show');
  var embedForm = document.querySelector('shopify-forms-embed');
  var embedFormShadowRoot = embedForm.shadowRoot;
  var product_name = embedFormShadowRoot.getElementById('custom#product_name');
  var product_number = embedFormShadowRoot.getElementById('custom#product_number');
  var product_url = embedFormShadowRoot.getElementById('custom#product_url');
  if (product_name) {
    product_name.value = window.productInfo.title;
    product_name.dispatchEvent(new Event('input'))
  }
  if (product_number) {
    product_number.value = window.productInfo.sku;
    product_number.dispatchEvent(new Event('input'))
  }
  if (product_url) {
    product_url.value = window.productInfo.url;
    product_url.dispatchEvent(new Event('input'))
  }
})*/

document.querySelector('[data-target="request-quote-form"]').addEventListener('click', function() {
  document.querySelector('.request-quote-popup').classList.add('_show');
  document.querySelector('[name="contact[product_number]"]').value = document.querySelector('#sku').innerText;
})

document.querySelector('.request-quote-popup .close-popup').addEventListener('click', function() {
  document.querySelector('.request-quote-popup').classList.remove('_show');
})



